import {smarketBaseApi,requestAll,post} from "./baseApi";
import config from '../config';
import {getSession} from "./public";
import $ from 'jquery'

//获取表单
const getForm = params=>{
    params={
        tenantId:config.tenantId,
        formId:config.formId,
    }
    return post("/api/member/form/get",params);
}
//发送验证码
const sendCheckCode = params => {
    params = {
        memberSchemaId:config.schemaId,
        action: 'resetpassword',
        intervalTime: '60',
        validTime: 600,
        ...params
    };
    return smarketBaseApi('/member/sendCheckCode', params);
};
//验证验证码
const checkCode = params => {
    params = {
        memberSchemaId:config.schemaId,
        action: 'resetpassword',
        ...params
    };
    return smarketBaseApi('/member/checkCode', params);
};
//验证唯一字段
const checkUnique = params =>{
    params = {
        memberSchemaId: config.schemaId,
        ...params
    };
    return smarketBaseApi('/member/checkUnique', params);
};
//提交注册
const userRegister = params =>{
    params = {
        memberFormId:config.formId,
        schemaId: config.schemaId,
        tenantId:config.tenantId,
        ...params
    };
    return smarketBaseApi('/member/register', params);
};

//获取当前注册用户的详细信息
const getMemberInfo = params =>{
    params = {
        tenantId:config.tenantId,
        schemaId: config.schemaId,
        isTemplate: -1,
        sess:getSession(),
        ...params
    };
    return smarketBaseApi('/api/member/contacts/info/get', params);
};

//更新注册用户信息
const UpdateMember = params =>{
    params = {
        memberFormId:config.memberFormId,
        schemaId: config.schemaId,
        tenantId:config.tenantId,
        sess:getSession(),
        ...params
    };
    return smarketBaseApi('/member/UpdateIdentityInfo', params);
};

//生成匿名用户id
const getId = params =>{
    params = {
        clientBrand: "",
        clientIP: "",
        clientType: "",
        clientVersion: "",
        ...params
    }
    return smarketBaseApi('/anonymous/getId', params);

};
const getDic = params=>{
    params={
        tenantId:config.tenantId,
        dicId:config.dicId,
    }
    return post('/dic/params/getTree', params);
}
export {
    sendCheckCode,
    checkUnique,
    userRegister,
    UpdateMember,
    getMemberInfo,
    getId,
    getForm,
    getDic,
    checkCode
}
